import { Box, Tooltip } from '@mui/material';
import type { MouseEventHandler, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../legacy/style/theme';
import Button from '../../../../design/panel/Button';

type Props = {
    isVisible: boolean;
    handleClick: MouseEventHandler;
};
export const ToggleSessionsVisibility: FC<Props> = ({ isVisible, handleClick }) => {
    const { t } = useTranslation();

    return (
        <Tooltip
            title={t(
                isVisible ? 'networkMap.sessionsPanel.toggleSessionsOn' : 'networkMap.sessionsPanel.toggleSessionsOff',
            )}
            placement="top"
            arrow
        >
            <Button onClick={handleClick}>
                <Box
                    sx={{
                        fontWeight: 'bold',
                        color: theme.color.blue.primary,
                    }}
                >
                    {t(isVisible ? 'networkMap.sessionsPanel.hide' : 'networkMap.sessionsPanel.show')}
                </Box>
            </Button>
        </Tooltip>
    );
};
